import React from 'react';

import { useEvieHomeContext } from '../EvieHomeProvider';
import { TASK_TYPES, CHAT_CONTENT_TYPES, HOME_STATUS } from '../utils';

import ReadingView from '../ReadingView';
import AudioView from '../AudioView';
import CapsuleView from '../CapsuleView';

const TaskController = () => {
  const { changeHomeStatus, selectTask, selectedTask } = useEvieHomeContext();
  const { __typename: type = '', contentType = '' } = selectedTask || {};
  const currentTaskType = contentType || type; // contentType is used for chat recommended content, __typename is used for daily exercises task

  const handleChangeHomeStatus = () => {
    changeHomeStatus(HOME_STATUS.IDLE);
  };

  switch (currentTaskType) {
    case TASK_TYPES.READING:
    case CHAT_CONTENT_TYPES.READING:
      return (
        <ReadingView
          changeViewStatus={handleChangeHomeStatus}
          selectedContent={selectedTask}
          selectContent={selectTask}
        />
      );

    case TASK_TYPES.AUDIO:
    case CHAT_CONTENT_TYPES.AUDIO:
      return (
        <AudioView
          changeViewStatus={handleChangeHomeStatus}
          selectedContent={selectedTask}
          selectContent={selectTask}
        />
      );

    case TASK_TYPES.CAPSULE:
    case CHAT_CONTENT_TYPES.SHORT_VIDEO:
      return (
        <CapsuleView
          changeViewStatus={handleChangeHomeStatus}
          selectedContent={selectedTask}
          selectContent={selectTask}
        />
      );

    default:
      return null;
  }
};

export default TaskController;
